import { Component, OnInit, Output, Input, EventEmitter, OnChanges, SimpleChanges, ViewChild, ElementRef } from '@angular/core';
import { trigger, style, animate, transition, state } from '@angular/animations';
import { UtilitiesService } from '../../../../services/utilities.service';
import { TranslateService } from '@ngx-translate/core';
import { InvalidMobileErrorService } from 'src/app/services/invlid-mobile-error.service';



@Component({
  selector: 'receipts-shipper',
  templateUrl: './shipper.component.html',
  styleUrls: ['./shipper.component.scss'],
  animations: [
    trigger('openClose', [
      state('open', style({
        opacity: 1,
        display: 'block'
      })),
      state('closed', style({
        opacity: 0,
        display: 'none'
      })),
      transition('open => closed', [
        animate('0.5s')
      ]),
      transition('closed => open', [
        animate('0.5s')
      ]),
    ]),
  ]
})
export class ShipperComponent implements OnInit, OnChanges {
  ngOnChanges(changes: SimpleChanges) {
    if (changes['changing'] != undefined) {
      var change = changes['changing'].currentValue
      if (change == true) {
        this.isOpen = change;
        this.shipper = { addressLine: '', mobile: '', name: '',
           shippmentReference: '',ShipperReference:'', ShipperReference2:'',
            accountNumber: undefined, email: '', taxNumber:'',
            shipperType: 0, 
            shipperTypeDetails: null
          };
      }
    }
  }
  @ViewChild("shippmentReference") inputEl: ElementRef;

  focusInput() {
    this.inputEl.nativeElement.focus()
  }
  @Output() shipperInfoObject = new EventEmitter();
  @Input() changing: boolean;
  @Input() enableChange;
  @Input() userAccounts: any[];
  @Input() countryCode;
  @Input() shipperTypes: any[];
  @Input() shipperNationalities: any[];
  @Input() shipperTypeDetails: any[];

  productTypeSelected: boolean;
  isOpen: boolean = true;
  isSa: boolean = false;
  shipper = {} as shipper;
  @Output() isEnableSelectConsigneeDetails = new EventEmitter();
  @ViewChild('isFocus') isFocus: ElementRef;
  branchSettings = JSON.parse(sessionStorage.getItem('branchSettings'));
  hasTax = false;

  constructor(private utilities: UtilitiesService,private translate: TranslateService,private mobileErrorService: InvalidMobileErrorService) {
    this.productTypeSelected = false;
    var branchSetting = JSON.parse(sessionStorage.getItem("branchSettings"));
    this.hasTax = branchSetting.filter((x) => x.Key == 33)[0] != undefined ? (branchSetting.filter((x) => x.Key == 39)[0].Value == "True"): false;
  }
  validatorObject = {
    Mobile: {
      valid: false,
      message: ''
    },
    name: {
      valid: false,
      message: ''
    },
    addressLine: {
      valid: false,
      message: ''
    },
    shippmentReference: {
      valid: true,
      message: ''
    },
    ShipperReference: {
      valid: true,
      message: ''
    },
    ShipperReference2: {
      valid: true,
      message: ''
    },
    email: {
      valid: true,
      message: ''
    },
    taxNumber: {
      valid: true,
      message: ''
    }
  }

  setShipperInfo(info,isClose?){
    if(info){
      this.shipper.name = info.name;
      this.shipper.mobile = info.mobile;
      this.shipper.addressLine = info.addressLine;
      this.shipper.shippmentReference = info.shippmentReference;
      this.shipper.email = info.email;
      this.shipper.ShipperReference = info.ShipperReference;
      this.shipper.ShipperReference2 = info.ShipperReference2;
      this.shipper.accountNumber = info.accountNumber;
      this.shipper.shipperType = info.shipperType;
      this.shipper.shipperTypeDetails = info.shipperTypeDetails;

      if (this.shipper?.mobile && this.shipper?.mobile !== "") {
        this.validatorObject.Mobile.valid = true;
        this.validatorObject.Mobile.message = '';
      }
      this.fillShipperInfo(isClose);
    }
  }

  checkRequiredField(value) {
    
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    var validEmail = re.test(String(this.shipper.email).toLowerCase());
    if ((this.shipper[value] == '' || this.shipper[value] == null || this.shipper[value] == undefined) && value != 'email')
    {
      
      this.validatorObject[value] = { valid: false, message: `<i class="unvalid armx - icon armx-cancel"></i> ${this.translate.instant('pages.createReceiptPage.errorMsgs.reqValueMsg',{
        fieldName: value
      })}`};
    }
    else
      if (value == 'name') {
        if ((this.shipper['name'].trim()).length < 4) {
          this.shipper['name'] = this.shipper['name'].trim();
          this.validatorObject[value] = { valid: false, message: `<i class="unvalid armx - icon armx-cancel"></i> ${this.translate.instant('pages.createReceiptPage.errorMsgs.shortValueMsg',{
            fieldName: value
          })}` };
        }
        else if ((this.shipper['name'].trim()).length > 165) {
          this.shipper['name'] = this.shipper['name'].trim();
          this.validatorObject[value] = { valid: false, message: `<i class="unvalid armx - icon armx-cancel"></i> ${this.translate.instant('pages.createReceiptPage.errorMsgs.longValueMsg',{
            fieldName: value
          })}` };
        }
        else {
          this.shipper['name'] = this.shipper['name'].trim();
          this.validatorObject[value] = { valid: true, message: '' };
        }
      }
      else if (value == 'email') {
        if (this.shipper.email != null && this.shipper.email.trim().length > 0 && !validEmail) {
          this.validatorObject['email'] = { valid: false, message: `<i class="unvalid armx - icon armx-cancel"></i> ${this.translate.instant('pages.createReceiptPage.errorMsgs.inValidEmail')}` };
        }
        else {
          this.validatorObject['email'] = { valid: true, message: '' };
        }
      }
      else if (value == 'taxNumber' && this.hasTax == true) {
        if (this.shipper.taxNumber != null && this.shipper.taxNumber.trim().length > 0 ) {
          this.validatorObject['taxNumber'] = { valid: true, message: '' };
        }
        else {
          this.validatorObject['taxNumber'] = { valid: false, message: `<i class="unvalid armx - icon armx-cancel"></i> ${this.translate.instant('pages.createReceiptPage.errorMsgs.invalidTaxNumber')}` };
        }
      }

      else if (value == 'addressLine') {
        if ((this.shipper['addressLine'].trim()).length < 9) {
          this.shipper['addressLine'] = this.shipper['addressLine'].trim();
          this.validatorObject[value] = { valid: false, message: `<i class="unvalid armx - icon armx-cancel"></i> ${this.translate.instant('pages.createReceiptPage.errorMsgs.shortValueMsg',{
            fieldName: value
          })}` };
        }
        else if ((this.shipper['addressLine'].trim()).length > 150) {
          this.shipper['addressLine'] = this.shipper['addressLine'].trim();
          this.validatorObject[value] = { valid: false, message: `<i class="unvalid armx - icon armx-cancel"></i> ${this.translate.instant('pages.createReceiptPage.errorMsgs.longValueMsg',{
            fieldName: value
          })}` };
        }
       
          else {
            this.shipper['addressLine'] = this.shipper['addressLine'].trim();
            this.validatorObject[value] = { valid: true, message: '' };
          }
      }

  }


  addNumberField(name,validation,ngModelValue){
   var div = document.getElementById("dynDiv");
 //onchange="onChangeValidation('${ngModelValue}')"   
     var html = `<div class="form-group" ><label class="control-label">${name}</label>
        <input class="form-control" #isFocus type="number"      
               autocomplete="disabled"
               ${validation}
               id=${ngModelValue}           
               /></div>
               <span style="color: red;" id="${ngModelValue}Span"></span> `;
      div.innerHTML +=html;
  }
  addDateTimeField(name,validation,ngModelValue){
 var div = document.getElementById("dynDiv");
     var html = `<div class="form-group" ><label class="control-label">${name}</label>
        <input class="form-control" #isFocus type="date"             
               autocomplete="disabled"
               ${validation}
               id=${ngModelValue}              
               /></div>
               <span style="color: red;" id="${ngModelValue}Span"></span> `;
      div.innerHTML +=html;
  }
  addField(name,validation, ngModelValue){
     var div = document.getElementById("dynDiv");
     var html = `<div class="form-group" ><label class="control-label">${name}</label>
        <input class="form-control" #isFocus              
               autocomplete="disabled"
               ${validation}
               id=${ngModelValue}              
                /></div>
                <span style="color: red;" id="${ngModelValue}Span"></span> `;
      div.innerHTML +=html;
  }

  addDropdownField(name,validation, ngModelValue){
     var div = document.getElementById("dynDiv");
     var html = `<div class="form-group">
        <label class="control-label">${name}</label>
        <select class="form-control" id=${ngModelValue} (ngModelChange)="dynOnChange($event)">        
          ${this.getOptions()}
        </select>
         <span style="color: red;" id="${ngModelValue}Span"></span> 
      </div>`;
      div.innerHTML +=html;
  }

  getOptions(){

    var options = ``;
    for(var i=0; i< this.shipperNationalities.length; i++){
      options+= `<option value="${this.shipperNationalities[i].nationalityCode}" >${this.shipperNationalities[i].name}</option>`;
    }
    return options;
  }

  dynOnChange(event){
    console.log(`dynOnChange event ${event}`);
  }

  onChangeFor(event){
   var div = document.getElementById("dynDiv");
   div.innerHTML = '';  

    var currentType = this.shipperTypes.filter(obj=> obj.id == event)[0];
    this.shipper.shipperTypeDetails =[];
    for(var i =0; i< currentType.shipperTypeDetails.length ; i++){
      if(currentType.shipperTypeDetails[i].dataType == "Number"){
            this.addNumberField(currentType.shipperTypeDetails[i].fieldName,currentType.shipperTypeDetails[i].validation,`shipper.shipperTypeDetails[${i}]`);
      }else if(currentType.shipperTypeDetails[i].dataType == "DateTime"){
            this.addDateTimeField(currentType.shipperTypeDetails[i].fieldName,currentType.shipperTypeDetails[i].validation,`shipper.shipperTypeDetails[${i}]`);
      }else if(currentType.shipperTypeDetails[i].dataType == "Dropdown"){
            this.addDropdownField(currentType.shipperTypeDetails[i].fieldName,currentType.shipperTypeDetails[i].validation,`shipper.shipperTypeDetails[${i}]`);
      }else {
         this.addField(currentType.shipperTypeDetails[i].fieldName,currentType.shipperTypeDetails[i].validation,`shipper.shipperTypeDetails[${i}]`);
      }
      this.shipper.shipperTypeDetails[i] = "tets"
    }
  
    const myElement = document.getElementById('shipper.shipperTypeDetails[0]');
    myElement.addEventListener('change',()=> this.dynValidation());

  if(currentType.shipperTypeDetails.length == 2){
      const myElement1 = document.getElementById('shipper.shipperTypeDetails[1]');
    myElement1.addEventListener('change',()=> this.dynValidation());
    }

    console.log("onChangeFor",currentType)
    this.shipper.shipperType = event;
  }
  shipperTypeValidation(){
        if(this.shipperTypes.length ==0){
      return true;
    }
    if(this.shipper.shipperType ==0 || this.shipper.shipperType== null){
      var doc =document.getElementById("shipperTypeSpan");
      doc.innerText= "Please select Shipper Type";
       return false;
    }else{
        var doc =document.getElementById("shipperTypeSpan");
      doc.innerText= "";
    }
    return true;
  }

  onChangeValidation(id){
    var doc = document.getElementById(id);
    console.log(`current doc (id) : ${doc} (${id})`);
    if(!doc){
      return;
    }
    this.dynValidation();
  }

  dynValidation(){
     var eleLength= this.shipper.shipperTypeDetails.length;
    for(var i =0; i< eleLength; i++){
      let val = document.getElementById(`shipper.shipperTypeDetails[${i}]`) as HTMLInputElement;
      this.shipper.shipperTypeDetails[i] = val.value;
    }
console.log(`this.shipper.shipperType ${this.shipper.shipperType}`);
    var currentType =this.shipper.shipperType;
    console.log(`currentType : ${JSON.stringify(currentType)}`);
    var isValid = true;
    if(currentType == 1){      
      // Citizen 
        console.log(`Citizen`);
     var cVal = this.shipper.shipperTypeDetails[0];
      console.log(`Citizen ${cVal}`);

     if(!cVal.startsWith("1")){
       console.log(`cVal start with 1`);
       var doc = document.getElementById(`shipper.shipperTypeDetails[0]Span`);
       doc.innerText =  "ID Number must start with 1"
        isValid =  false;
     }else{
         var doc = document.getElementById(`shipper.shipperTypeDetails[0]Span`);
       doc.innerText =  ""
       isValid =  true;
     }
      var cDate =this.shipper.shipperTypeDetails[1];
     if(cDate == ''){
        var doc = document.getElementById(`shipper.shipperTypeDetails[1]Span`);
        doc.innerText = "This field is required";
        isValid =  false;
     }else{
         var doc = document.getElementById(`shipper.shipperTypeDetails[1]Span`);
       doc.innerText =  ""
       isValid =  true;
     }
     return isValid;
    }else if(currentType ==2){
        var cVal = this.shipper.shipperTypeDetails[0];

     if( !cVal.startsWith("2")){
        document.getElementById(`shipper.shipperTypeDetails[0]Span`).innerText = "ID Number must start with 2";
          isValid =  false;
     }else{
       document.getElementById(`shipper.shipperTypeDetails[0]Span`).innerText = "";
       isValid =  true;
     }
    var cDate =this.shipper.shipperTypeDetails[1];
     if(cDate == ''){
        var doc = document.getElementById(`shipper.shipperTypeDetails[1]Span`);
        doc.innerText = "This field is required";
        isValid =  false;
     }else{
         var doc = document.getElementById(`shipper.shipperTypeDetails[1]Span`);
       doc.innerText =  ""
       isValid =  true;
     }
     return isValid;
    }else if(currentType == 4){
       var cVal = this.shipper.shipperTypeDetails[0];
       if(cVal.length != 10 ){
           document.getElementById(`shipper.shipperTypeDetails[0]Span`).innerText = "Border Number must be 10 digits";
        return false;
       }else{
        document.getElementById(`shipper.shipperTypeDetails[0]Span`).innerText = "";
       }
    }else if(currentType == 5){
  var cVal = this.shipper.shipperTypeDetails[0];
       if(cVal.length > 15 || cVal.length < 9 ){
           document.getElementById(`shipper.shipperTypeDetails[0]Span`).innerText = "ID Number length must be between 9-15";
        return false;
       }else{
        document.getElementById(`shipper.shipperTypeDetails[0]Span`).innerText = "";
       }
    }else if(currentType == 6){
       var cVal = this.shipper.shipperTypeDetails[0];
       if(cVal.length > 9 || cVal.length < 6 ){
           document.getElementById(`shipper.shipperTypeDetails[0]Span`).innerText = "ID Number length must be between 6-9";
        return false;
       }else{
        document.getElementById(`shipper.shipperTypeDetails[0]Span`).innerText = "";
       }
    }


    return true;
  }
  fillShipperInfo(isCLose?) {
    if(this.shipperTypes && this.shipperTypes.length > 0){
   var isValid=  this.shipperTypeValidation();
   if(!isValid){
    return;
   }
    var isValidDyn=  this.dynValidation();
   if(!isValidDyn){
    return;
   }
    var eleLength= this.shipper.shipperTypeDetails.length;
    for(var i =0; i< eleLength; i++){
      let val = document.getElementById(`shipper.shipperTypeDetails[${i}]`) as HTMLInputElement;
      this.shipper.shipperTypeDetails[i] = val.value;
    }
    }

  
    this.checkRequiredField('name');
    this.checkRequiredField('addressLine');
    this.checkRequiredField('email')
    if (this.validatorObject.Mobile.valid
      && this.validatorObject.email.valid 
      && this.validatorObject.name.valid 
      && this.validatorObject.addressLine.valid 
      && this.validatorObject.shippmentReference.valid 
      && this.validatorObject.ShipperReference.valid 
      && this.validatorObject.ShipperReference2.valid) {
      if (this.shipper.accountNumber == undefined)
        this.shipper.accountNumber = this.userAccounts.filter(x => x.IsDefault == true)[0].Number;
      var account = this.userAccounts.filter(x => x.Number == this.shipper.accountNumber)[0];
      delete account["IsDefault"]
      this.shipperInfoObject.emit({ shipper: this.shipper, account: account })
      this.productTypeSelected = true;
      this.isEnableSelectConsigneeDetails.emit(true);
      this.isOpen = isCLose ? !isCLose : !this.isOpen;
    }
  }
  resolvePhone(phoneNumber) {
    var branchSettings = JSON.parse(sessionStorage.getItem('branchSettings'))
    var isTouchPointIntegration = branchSettings.filter(x => x.Key == 11)[0].Value;
    this.utilities.resolvePhone({
      CountryCode: this.countryCode,
      PhoneNumber: phoneNumber
    },
      (res) => {
        this.shipper.mobile = res.PhoneNumber;
        this.validatorObject.Mobile = {
          valid: true,
          message: ''
        }

        if (isTouchPointIntegration == 'True') {

          this.utilities.getContactByPhoneNumber(res.PhoneNumber, (result) => {

            if (result.FullAddress != null && result.FirstName != null) {
              this.shipper.name = result.FirstName + ' ' + result.LastName;
              this.shipper.addressLine = result.FullAddress.Description;
              this.focusInput();
              this.checkRequiredField('name')
              this.checkRequiredField('addressLine')
              this.checkRequiredField('email')
            }
          }, (err) => {
          });
        }
        else {
          if (phoneNumber && phoneNumber !== "") {
            this.validatorObject.Mobile.valid = true;
            this.validatorObject.Mobile.message = '';
          }
          else {
            this.validatorObject.Mobile.valid = false;
            this.validatorObject.Mobile.message = '<i class="unvalid armx-icon armx-cancel"></i> ' + `${this.translate.instant('pages.createReceiptPage.errorMsgs.fieldReq')}`;
          }
        }

      }, (err) => {
        this.validatorObject.Mobile = {
          valid: false,
          message: '<i class="unvalid armx-icon armx-cancel"></i> ' + this.mobileErrorService.getErrorMessage(err),
        }
      })
  }
  change() {
    this.isEnableSelectConsigneeDetails.emit(false);
    this.isOpen = !this.isOpen;
  }



  ngOnInit() {
    // this.isFocus.nativeElement.focus();
  }
}
